//------------------------------------------------------------------------------
// History Generator -----------------------------------------------------------
import { createBrowserHistory } from 'history';
//------------------------------------------------------------------------------
// Singleton History -----------------------------------------------------------
export default createBrowserHistory({});
